import StickersAdvice from './StickersAdvice';

export default StickersAdvice;
